import { DefaultTriggerHandler } from '@leverege/molten/screens'
import DataStore from '@leverege/data-store'
import { GlobalState } from '@leverege/ui-redux'

export default class PlyLayerTriggerHandler extends DefaultTriggerHandler {
  constructor( props, context ) {
    super( props, context )
    this.isFirstRefresh = true
    this.refreshInterval = null
    this.hasNextSA = props.hasNextSA
    this.shellDelegate = props.shellDelegate
    this.lastRefreshTime = 0
  }

  async init() {
    await this.loadData()

    try {
      const { accessToken } = await GlobalState.dispatch( this.shellDelegate.get( { accessToken : true } ) )
      const db = DataStore.createDatabase( accessToken )
      await db.signIn( accessToken.jwt )

      const handleEvent = () => {
        const now = Date.now()
        // Don't refresh more than once every 2 seconds
        if ( now - this.lastRefreshTime < 2000 ) {
          return
        }
        
        this.lastRefreshTime = now
        this.loadData()
      }

      db.on( 'subAssemblyJob/id', handleEvent )
      
      this.listener = db
      
      this.setupRefreshInterval()
    } catch ( err ) {
      console.error( 'Error setting up PlyLayerTriggerHandler:', err )
    }
  }

  async setupRefreshInterval() {
    this.clearRefreshInterval()

    const REFRESH_INTERVAL = 8000

    this.refreshInterval = setInterval( async () => {
      await this.loadData()
    }, REFRESH_INTERVAL )
  }

  clearRefreshInterval() {
    if ( this.refreshInterval ) {
      clearInterval( this.refreshInterval )
      this.refreshInterval = null
    }
  }

  cleanup() {
    super.cleanup()

    if ( this.listener ) {
      this.listener.off( 'subAssemblyJob/id' )
      this.listener = null
    }

    this.clearRefreshInterval()
  }
}
